import { IVideoList } from "../model/home";
import { getData } from "../utils/HttpUtils";

export async function getMyVideoList(subject: string, status: string, order: string, ref_id?: string): Promise<IVideoList> {
  return getData("/api/solve/personal_videos", {
    subject, status, order
   });
}
